import React from "react";

export default function SharedRaw() {
  const [content, setContent] = React.useState(null);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    const path = window.location.pathname;
    // Expecting /shared/raw/:shareId/:name
    const match = path.match(/^\/shared\/raw\/([^/]+)\/(.+)$/);
    if (!match) {
      setError("Invalid URL");
      return;
    }
    const [, shareId, name] = match;
    fetch(`/api/shared/raw/${shareId}/${encodeURIComponent(name)}`)
      .then(r => r.ok ? r.text() : Promise.reject("Not found"))
      .then(setContent)
      .catch(() => setError("Note not found or has been deleted"));
  }, []);

  if (error) return <pre style={{color: 'red', padding: 24}}>{error}</pre>;
  if (content === null) return <pre style={{opacity: 0.6, padding: 24}}>Loading...</pre>;
  return <pre style={{padding: 24, whiteSpace: 'pre-wrap', wordBreak: 'break-word'}}>{content}</pre>;
}
